<template>
  <div id="main">
    <div class="wrapper rsu" v-if="$store.state.isLoggedIn">
      <template>
        <app-header @onTrigger="drawer = !drawer"></app-header>
        <v-navigation-drawer
          fixed
          v-model="drawer"
          dark
          app
          :class="{ menu: true, default: isDefaultTheme}"
          class="background-gradientBlue"
        >
        <!-- :class="{ menu: true, default: isDefaultTheme, primary: !isDefaultTheme }" -->
          <v-layout>
            <v-flex class="text-xs-right">
              <v-btn fab flat dark small @click="drawer = false" class="hidden-sm-and-up">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <ul class="home-m menu-list"></ul>

          <div class="text-xs-center">
            <div class="avatar mb-3">
              <!-- <div class="avatar-img" style="position: relative"> -->
              <!-- <div style="position: absolute; right: -5px; top: -5px">
                  <template v-if="
                    !selectedBot.pagerole ||
                    (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "></template>
                </div> -->

              <div>
                <v-img
                  class="mx-auto"
                  src="/static/img/depa_Logo_web.png"
                  height="50%"
                  width="50%"
                ></v-img>
              </div>
              <!-- </div> -->
            </div>
          </div>
          <!-- <div class="text-xs-center" style="color:white;" v-if="$store.state.userid">
            {{ $store.state.userid }}
          </div> -->

          <div class="mt-1">
            <div>
              <ul class="menu-list">
                <template>
                  <div v-for="(item, i) in privilege.privilegegroup" :key="i">
                    <!-- <template v-if="params.length - 2 == i">
                      <v-divider />
                    </template> -->
                    <template
                      v-if="item.children.length === 0 && !['event', 'Training', 'conversation'].includes(item.name) && item.checked && item.name!='Jobd2u'"
                    >
                      <router-link :to="'/' + $i18n.locale() + '/' + item.path">
                        <li tabindex="0">
                          <span class="fs-16">{{ $t(item.meta.title) }}</span>
                        </li>
                      </router-link>
                    </template>
                    <!-- {{ item.name }} -->
                    <template v-if="item.name === 'event' && item.checked">
                      <a target="_blank" :href="'https://zipeventapp.com/Admin/event/Upcoming'">
                        <li tabindex="0">
                          <span class="fs-16">{{ $t('Event') }}</span>
                        </li>
                      </a>
                    </template>
                    <template v-if="item.name === 'Training' && item.checked">
                      <a target="_blank" :href="`${botpressUrl}/modules/misunderstood`">
                        <li tabindex="0">
                          <span class="fs-16">{{ $t('Training') }}</span>
                        </li>
                      </a>
                    </template>
                    <template v-if="item.name === 'conversation' && item.checked">
                      <a target="_blank" :href="`${botpressUrl}/qna`">
                        <li tabindex="0">
                          <span class="fs-16">{{ $t('Conversation') }}</span>
                        </li>
                      </a>
                    </template>

                    <template v-if="item.children.length > 0">
                      <v-list-group :value="true" v-if="item.checked">
                        <template v-slot:activator>
                          <span class="fs-16" style="color: white;margin-left: 10px;">{{ $t(item.meta.title) }}</span>
                        </template>

                        <div v-for="subItem in item.children" :key="subItem.name" sub-group>
                          <template v-if="subItem.checked">
                            <router-link
                              :to="'/' + $i18n.locale() + '/' + item.path + '/' + subItem.path"
                            >
                              <li tabindex="0">
                                <span class="fs-16">{{ $t(subItem.meta.title) }}</span>
                              </li>
                            </router-link>
                          </template>
                        </div>
                      </v-list-group>
                    </template>
                  </div>

                  <li
                    tabindex="0"
                    @click="logout"
                    :data-intro="
                      $t('Click here, if your setting is finished or if you want to sigh out.')
                    "
                  >
                    <span class="fs-16">{{ $t('Sign Out') }}</span>
                  </li>

                  <!-- </v-list> -->
                </template>

                <!-- <template
                  v-if="
                    !selectedBot.pagerole ||
                    (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <router-link
                    :to="'/' + $i18n.locale() + '/welcome'"
                    :data-intro="
                      $t(
                        'Make a great First Impression moment for your customers by setting Welcome Message here.'
                      )
                    "
                    data-position="right"
                    v-if="isShowMenu('welcome')"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Welcome Message') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link
                    v-if="isShowMenu('conversation')"
                    :to="'/' + $i18n.locale() + '/conversation'"
                    :data-intro="
                      $t(
                        'This Conversation page is like a heart of CHATBOT, the page will collect all pattern on how Bot replies all messages.'
                      )
                    "
                  >
                    <li tabindex="0">
                      <span>{{ $t('Conversation') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link v-if="isShowMenu('member')" :to="'/' + $i18n.locale() + '/member'">
                    <li tabindex="0">
                      <span>{{ $t('Member') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link
                    v-if="isShowMenu('allinonechat') || isShowMenu('livechat')"
                    :to="'/' + $i18n.locale() + '/allinonechat'"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Livechat') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link v-if="isShowMenu('project')" :to="'/' + $i18n.locale() + '/project'">
                    <li tabindex="0">
                      <span>{{ $t('Project') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link
                    v-if="isShowMenu('techhunt')"
                    :to="'/' + $i18n.locale() + '/techhunt'"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Tech hunt') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <router-link
                    v-if="isShowMenu('voucherreport')"
                    :to="'/' + $i18n.locale() + '/voucherreport'"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Voucher Report') }}</span>
                    </li>
                  </router-link>
                </template>
                <template>
                  <a
                    v-if="isShowMenu('event')"
                    target="_blank"
                    :href="'https://zipeventapp.com/Admin/event/Upcoming'"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Event') }}</span>
                    </li>
                  </a>
                </template>
                <template>
                  <router-link v-if="isShowMenu('jobd2u')" :to="'/' + $i18n.locale() + '/jobd2u'">
                    <li tabindex="0">
                      <span>{{ $t('JOBD2U') }}</span>
                    </li>
                  </router-link>
                </template>
                <router-link
                  v-if="isShowMenu('broadcast')"
                  :to="'/' + $i18n.locale() + '/broadcast'"
                  :data-intro="
                    $t(
                      'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
                    )
                  "
                >
                  <li tabindex="0">
                    <span>{{ $t('Broadcast') }}</span>
                  </li>
                </router-link>
                <template>
                  <router-link
                    v-if="isShowMenu('rolemanager')"
                    :to="'/' + $i18n.locale() + '/rolemanager'"
                  >
                    <li tabindex="0">
                      <span>{{ $t('Role Manager') }}</span>
                    </li>
                  </router-link>
                </template>

                <router-link
                  v-if="isShowMenu('dashboard')"
                  :to="'/' + $i18n.locale() + '/dashboard'"
                  :data-intro="
                    $t(
                      'It is the place where you can see both analytics data; conversation and customer'
                    )
                  "
                >
                  <li tabindex="0">
                    <span>{{ $t('Report') }}</span>
                  </li>
                </router-link>
                <template>
                  <router-link
                    v-if="isShowMenu('training')"
                    :to="'/' + $i18n.locale() + '/training'"
                    :data-intro="
                      $t('This page is for training Bot to be smarter, and reduce default words !')
                    "
                  >
                    <li tabindex="0">
                      <span>{{ $t('Training') }}</span>
                    </li>
                  </router-link>
                </template>
                <v-divider />
                <template>
                  <router-link
                    v-if="isShowMenu('billing')"
                    :to="'/' + $i18n.locale() + '/billing'"
                    :data-intro="
                      $t(
                        'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
                      )
                    "
                  >
                    <li tabindex="0">
                      <span>{{ $t('Setting') }}</span>
                    </li>
                  </router-link>
                </template>
                <li
                  tabindex="0"
                  @click="logout"
                  :data-intro="
                    $t('Click here, if your setting is finished or if you want to sigh out.')
                  "
                >
                  <span>{{ $t('Sign Out') }}</span>
                </li> -->
              </ul>
            </div>
          </div>
        </v-navigation-drawer>
        <v-content>
          <slot></slot>
        </v-content>

        <app-footer />
      </template>
    </div>

    <!-- <modal-welcome></modal-welcome> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
import dropdown from 'vue-dropdowns'
import moment from 'moment'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalWelcome from '@/components/elements/ModalWelcome'
import config from '@/config'

import ViewPackage from '@/components/view/setting/ViewPackage'

import api from '@/api'

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome,
  },
  computed: {
    botpressUrl() {
      // console.log('ggg', config, process.env)
      return config.botpressUrl || process.env.BOTPRESS_URL
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome',
    }),
    pluginMenu() {
      return 'Plug-In'
    },
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function () {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function () {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function () {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function () {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function () {
      // let options = []
      // let vm = this
      // $.each(vm.botlist, function (index, val) {
      //   if (val.pageid != vm.selectedBot.pageid) {
      //     options.push({ name: val.pagename, value: val.pageid })
      //   }
      // })

      return this.botlist
        .map((el) => {
          if (el.pageid == this.selectedBot.pageid) return null
          return { name: el.pagename, value: el.pageid }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    },
    filterBotlist: function () {},
  },
  data: function () {
    return {
      drawer: null,
      showAds: true,
      autostart: false,
      privilege: [],
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish'),
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null,
      // params: this.$router.options.routes[this.$router.options.routes.length - 1].children.filter(
      //   (item) => item.checked || item.checked === false
      // ),
    }
  },
  mounted: async function () {
    var vm = this
    vm.$validator.localize(vm.currentLang)
    var now = moment()
    var expriedDate = moment(this.$store.state.selectedBot.expireat)
    this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))

    await this.getAdminGroup()
    // var responseSubGroup = await this.getAdminSubGroup()
    // var responseAdmin = await this.getAdmins()
    // this.projectdata = await this.getProject()

    vm.selectedOption = {
      name: vm.selectedBot.pagename,
      value: vm.selectedBot.pageid,
    }
    vm.getSetting(function (contents) {
      vm.$store.dispatch('updateSetting', contents)
    })

    vm.getWelcomeMessage(function (welcomeMessage) {
      vm.$store.dispatch('updateWelcomeMessage', welcomeMessage)
    })

    // this.$tours['myTour'].start()

    if (vm.showModalWelcome) {
      // vm.openTutorial()
    }
  },
  created: function () {
    var vm = this
    if (
      localStorage.getItem('hideads') &&
      localStorage.getItem('hideads').includes(this.selectedBot.pageid)
    ) {
      this.showAds = false
    }
  },
  methods: {
    getAdminGroup() {
      return new Promise((resolve, reject) => {
        api.getAdminsById(localStorage.getItem('userid'), (err, response) => {
          this.privilege = response.data
          resolve()
        })
      })
    },
    closeAds() {
      var closeads = ''
      if (
        localStorage.getItem('hideads') &&
        !localStorage.getItem('hideads').includes(this.selectedBot.pageid)
      ) {
        closeads = localStorage.getItem('hideads') + ',' + this.selectedBot.pageid
      } else {
        closeads = this.selectedBot.pageid
      }
      localStorage.setItem('hideads', closeads)
      this.showAds = false
    },
    isShowMenu(menu) {
      // conversation
      // comment
      // broadcast
      // template
      // livechat
      // dashboard
      // training
      // billing
      // if (this.selectedBot.theme == 'depa') {
      //   if (this.$store.state.privilege.see && this.$store.state.privilege.see.length) {
      //     if (this.$store.state.privilege.see.includes(menu)) {
      //       return 1
      //     } else {
      //       return 0
      //     }
      //   } else {
      //     if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //       return ['techhunt', 'project', 'allinonechat'].includes(menu)
      //     } else if (this.$store.state.privilege && this.$store.state.privilege.role == 'admin') {
      //       return ![
      //         'billing',
      //         'training',
      //         'conversation',
      //         'welcome',
      //         'rolemanager',
      //         'allinonechat',
      //       ].includes(menu)
      //     } else if (
      //       this.$store.state.privilege &&
      //       this.$store.state.privilege.role == 'superadmin'
      //     ) {
      //       return true
      //     } else return false
      //   }
      // } else if (['101836095321926', '367570166993820'].includes(this.selectedBot.pageid)) {
      //   if (this.$store.state.privilege && this.$store.state.privilege.mjd_management == true) {
      //     return true
      //   } else {
      //     this.$router.push('template')
      //     return ['template'].includes(menu)
      //   }
      // } else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
      //   return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
      // } else
      return true
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    clickAds() {
      var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      this.$ga.event('event', prefix + 'banner_5999', this.selectedBot.pagename)
      this.$router.push('upgrade')
    },
    logout: function () {
      var vm = this
      var text = vm.$t('Do you want to Logout?')

      if (vm.selectedBot.theme == 'ticket2') {
        text = 'หากคุณลงชื่อออก ระบบจะทำการ Checkout ด้วย'
      }
      vm.$swal
        .fire({
          title: text,
          type: 'question',
          showCancelButton: true,
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            if (vm.selectedBot.theme == 'ticket2') {
              await vm.$swal.fire({
                type: 'success',
                text: 'ลงชื่อออกและ Checkout สำเร็จ',
              })
            }
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    selectBot: function (page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function (index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid,
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        $.each(response.data, function (index, val) {
          contents[val.contenttype] = val
        })
        callback(contents)
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid,
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text',
                },
              ],
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function (index, val) {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics,
                ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square',
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages,
        })
      })
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.botStatus = bot.status
      this.$store.dispatch('loading')
    },
  },
}
</script>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}

.v-list__group__header {
  display: flex;
  justify-content: space-between;
  font-size: 0.95em;
  font-weight: 300;
  background-repeat: no-repeat;
  background-position: left 15px center;
  background-size: auto 20px;
  transition: all 0.15s linear;
  /* padding: 1em 1em 1em 3em; */
  border-radius: 100px;
  padding: 10px;
  margin: 6px 30px 6px 20px;
  cursor: pointer;

  .v-list__group__header__append-icon {
    padding-left: 0px;
  }

  v-list-item-title {
    margin-left: 10px;
  }
}

.v-list {
  padding: 0px;

  .v-list__group--active:before {
    background: none !important;
  }

  .v-list__group--active::after {
    background: none !important;
  }
}

.v-list__group__items {
  padding-left: 20px !important;
}

.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }

    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      /* padding: 1em 1em 1em 3em; */
      border-radius: 100px;
      padding: 10px;
      margin: 6px 30px 6px 20px;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }

      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }

      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }

      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }

      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue